// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"SubscribeButton_subscribe__3HUcd"};